import { render, staticRenderFns } from "./PaymentForm.vue?vue&type=template&id=073f3c98"
import script from "./PaymentForm.vue?vue&type=script&lang=ts"
export * from "./PaymentForm.vue?vue&type=script&lang=ts"
import style0 from "./PaymentForm.vue?vue&type=style&index=0&id=073f3c98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports